import {Logo as LogoBase} from '@yandex-delivery/blocks'
import React from 'react'

import {useConfig} from '../../../config'

export function Logo() {
  const {brand, lang} = useConfig()

  return (
    <LogoBase brand={brand === 'yango' ? 'yango' : 'yandex'} component="a" href="/" lang={lang} />
  )
}
